import { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import { useAuth } from '@/hooks/useAuth'
import { useIsMobile } from '@/hooks/use-mobile'
const Layout = () => {
  const { athlete, isLoading } = useAuth()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const location = useLocation()
  const isMobile = useIsMobile()

  // Reset sidebar state when route changes
  useEffect(() => {
    if (window.innerWidth < 768) {
      setSidebarOpen(false)
    }
  }, [location.pathname])

  // Auto-close sidebar only on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false)
      }
    }

    // Set initial state
    handleResize()

    // Update on resize
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev)
  }

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#10181D]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    )
  }

  if (!athlete) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#10181D]">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4 text-white">Please log in</h1>
          <p className="mb-4 text-gray-300">You need to log in to access the athlete dashboard.</p>
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Only show sidebar on desktop */}
      {!isMobile && <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />}

      <div
        className="flex-1 flex flex-col overflow-hidden"
        style={{
          paddingLeft: !isMobile && sidebarOpen ? '16rem' : !isMobile ? '4rem' : '0',
          transition: 'padding-left 300ms',
        }}
      >
        <Header />

        <main className="flex-1 px-4 py-4 md:px-6 md:py-6 overflow-y-auto w-full max-w-[1200px] mx-auto relative">
          {/* Updated Gradient overlay */}
          <div className="fixed inset-0 -z-10 bg-linear-to-br from-[#000000] via-[#0a1e29] to-[#003b4d]"></div>

          <div className="md:pr-0">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout
